import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 生词列表UI组件
 * 纯展示型组件，负责渲染生词列表
 */
import React from 'react';
import { Button } from '../../core/Button/index.js';
/**
 * 生词列表UI组件
 * 纯展示型组件，负责渲染生词列表
 */
export const VocabularyList = ({ items, stats, loading, error, hasMore, onLoadMore, searchText = '', renderVocabularyItem, className = '', }) => {
    if (error) {
        return (_jsxs("div", { className: `text-center py-8 ${className}`, children: [_jsx("p", { className: "text-interactive-coral-red mb-4", children: error }), _jsx(Button, { variant: "secondary", onClick: () => window.location.reload(), children: "Retry" })] }));
    }
    // Loading state specifically for when the list is empty
    if (loading && items.length === 0) {
        return _jsx("div", { className: "text-center py-8 text-gray-600", children: "Loading vocabularies..." });
    }
    // Empty state after loading (and potentially search)
    if (!loading && items.length === 0) {
        return (_jsx("div", { className: "text-center py-8 text-gray-600", children: searchText ? `No vocabularies found for "${searchText}"` : 'Your vocabulary book is empty' }));
    }
    // Main rendering logic for non-empty list
    return (_jsxs("div", { className: className, children: [' ', _jsxs("div", { className: "mb-4 text-sm text-gray-600", children: ["Total ", stats.totalCount, " vocabularies"] }), _jsx("ul", { className: "space-y-3", children: items.map((item, index) => (
                // Add React.Fragment with key here
                _jsx(React.Fragment, { children: renderVocabularyItem(item, index) }, item.id || index))) }), hasMore && (_jsxs("div", { className: "text-center mt-6", children: [' ', _jsx(Button, { variant: "secondary", onClick: onLoadMore, loading: loading && items.length > 0, disabled: loading && items.length > 0, children: loading && items.length > 0 ? 'Loading...' : 'Load More' })] }))] }));
};
export default VocabularyList;
//# sourceMappingURL=VocabularyList.js.map